import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { NavLink } from '../../navigation.models'
import { NavigationService } from '../../navigation.service'
import { Subscription, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AlertService } from '../../../alert/alert.service';
import { Router } from '@angular/router';
import { AppService } from '../../../../../app.service';

@Component({
  selector: 'app-navLink-dialog',
  templateUrl: './navLink-dialog.component.html',
  styleUrls: ['./navLink-dialog.component.scss']
})

export class NavLinkDialogComponent implements OnInit {
  accessUser=['Create','Update','Delete']

  @Output() closeRequest = new EventEmitter<string>();
  public form: FormGroup;
  @Input() item: any;
  searchFilter: any = {};
  public parent: any[];
  public common: any;
  subscription: Subscription;
  public heading: boolean = true;
  public DataMap: NavLink[] = [];
  public ParentListCtrl: FormControl = new FormControl();
  private _onDestroy = new Subject<void>();
  public parentflt: any;
  public menuflt: any;
  public data1: NavLink[] = [];
  IsDeleted: boolean


  Source = [
    {
      id: 'ERP',
      name: 'ERP'
    },
    {
      id: 'LCP',
      name: 'LCP'
    }
  ]
  constructor(
    public fb: FormBuilder, public navservice: NavigationService,
     public alertService: AlertService,private router:Router,
    public commonService:AppService) {
    this.form = this.fb.group({
      navLinkParentId: [null],
      title: ['', Validators.required],
      linkText: ['',Validators.required],
      iconClass: [''], 
    });
  }
  linkOrderId:any
  ngOnInit() {
    this.GetAllNavLink()
    this.ParentListCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(val => {
        this.parentflt = this.searchParentList(val);
      });
    this.common = this.item;
    if (this.common) {
    }
    else {
      if (this.common == undefined || this.common.NavLinkId == null) {
        let a: any = new NavLink()
        a.Title = '';
        a.Url = '';
        a.IconClass = '';
        a.IconUrl = '';
        a.LinkText = '';
        a.LinkOrder = null;
        a.linkJson = null;
        a.Access =null;
        this.common = a;
      }
    }
    if (this.common && this.common?.navLinkId) {
      this.common.source = this.common.source;
    }
    else {
      this.common.source = 'LCP'
    }
    
  }

  GetAllNavLink() {
    let obj = {}
    this.navservice.listParentNavLinkData(obj)
      .subscribe(data => {
        if (data) {
          this.parentflt = data as Array<NavLink>;
          this.data1 = this.parentflt;
        }
      });
  }

  searchParentList(value: string) {
    let filter = value.toLowerCase();
    this.menuflt = this.data1;
    return this.menuflt.filter((n: any) => n.title.toLowerCase().includes(filter));
  }


  closeDialog() {
    this.closeRequest.emit('closeForm');
  }

  onUserSubmit(values: Object): void {
    if (this.form.valid) {
      let user: any = new NavLink();
      Object.assign(user, this.form.getRawValue());
      user.linkJson = JSON.stringify(
        {
          path: user['url'],
          breadcrumb: user['linkText'],
          ScreenName: user['linkText']
        });
      if (this.common.navLinkId) {
        user.NavLinkId = this.common.navLinkId;
        user.IsDeleted = false;
        this.navservice.UpdateNavLink(user)
          .subscribe(
            data => {
              this.alertService.success('Navigation Link Updated');
              this.closeDialog();
              this.router.navigate(['nav-link']);
              this.reloadComponent()
            },
            (error) => {
              this.alertService.error('Navigation Link update Error');
            }
          );
      }

      else {
        this.navservice.AddNavLink(user)
          .subscribe(
            {
              next: (data) => {
                this.alertService.success('Navigation Link Saved');
                this.closeDialog();
              },

              error: (error) => {
                this.alertService.error('Navigation Link Save Error');
              }
            });
      }
    }

  }
  reloadComponent() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['nav-link']);
    });
  }

  error=false 
  preventEmpty() {
    const sanitize = (val: string): string =>
      val?.replace(/^\s+/, '').replace(/\s{2,}/g, ' ') || '';
    const fields = ['title', 'linkText', 'iconClass'];
    fields.forEach(field => {
      const control = this.form.get(field);
      if (control) {
        const sanitized = sanitize(control.value);
        control.setValue(sanitized, { emitEvent: false });
      }
    });
    const isEmpty = fields.some(field => {     
      const value = this.form.get(field)?.value;
      return value.trim() === '';
    });
    this.error = isEmpty;   
  }
 
}

